<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.profile.edition') }}
      </h1>
      <div class="alert alert-warning">
        <strong>{{ $t('label.profile.warning') }}</strong>
        <p>{{ $t('label.profile.information') }}</p>
      </div>
      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t("error." + `${responseErr}`) }}
          </strong>
        </div>

        <div
          v-if="profile"
          id="accordion"
        >
          <div class="card rounded-0 mb-4">
            <div
              id="headingOne"
              data-bs-toggle="collapse"
              href="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              class="card-header font-accent fw-bold"
            >
              Détails
            </div>
            <div
              id="collapseOne"
              aria-labelledby="headingOne"
              data-bs-parent="#accordion"
              class="card-body collapse show"
            >
              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.profile.selectedRoleName') }}
                </label>
                <input
                  v-model="criterias.selectedRoleName"
                  :class="status(v$.criterias.selectedRoleName)"
                  :placeholder="$t('label.profile.selectedRoleName')"
                  type="text"
                  class="form-control rounded-0"
                  disabled
                >
              </div>

              <div class="col mt-4">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.profile.selectedRoleDescription') }}
                </label>
                <input
                  v-model="criterias.selectedRoleDescription"
                  :class="status(v$.criterias.selectedRoleDescription)"
                  :placeholder="$t('label.profile.selectedRoleDescription')"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>

              <div class="col mt-4">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.profile.selectedRoleLot') }}
                </label>
                <input
                  v-model="criterias.selectedRoleLot"
                  :class="status(v$.criterias.selectedRoleLot)"
                  :placeholder="$t('label.profile.selectedRoleLot')"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="v$.criterias.selectedRoleLot.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <!-- Permissions -->
              <div class="col mt-4">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.profile.selectedRolePermissions') }}
                </label>
                <multiselect
                  v-model="criterias.selectedRolePermissions"
                  :class="status(v$.criterias.selectedRolePermissions)"
                  :options="permissions"
                  :searchable="false"
                  :close-on-select="true"
                  :multiple="true"
                  :show-labels="true"
                  class="rounded-0"
                  :placeholder="$t('label.profile.selectedRolePermissions')"
                />
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="v$.criterias.selectedRolePermissions.required.$invalid">{{ $t('error.MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col mt-4">
                <div class="form-check">
                  <input
                    id="internal"
                    v-model="criterias.selectedRoleInternal"
                    :class="status(v$.criterias.selectedRoleInternal)"
                    class="form-check-input"
                    type="checkbox"
                    value=""
                  >
                  <label
                    class="form-check-label fw-bold mb-1"
                    for="internal"
                  >
                    {{ $t('label.profile.selectedRoleInternal') }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card card-body bg-light mb-4">
          <button
            type="button"
            class="btn btn-primary rounded-pill font-custom font-inverted btn-export"
            @click="editProfile()"
          >
            {{ $t("button.save") }}
          </button>
        </div>
      </div>
    </div>
    <!-- Success Modal -->
    <div
      id="successModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="successModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="successModalLabel"
              class="modal-title"
            >
              {{ $t('label.modal.SUCCESS_MODAL_LABEL') }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="leavePage()"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-success">
              <p id="successModalMsg" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div
      id="errorModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="errorModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="errorModalLabel"
              class="modal-title"
            >
              {{ $t('label.modal.ERROR_MODAL_LABEL') }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="leavePage()"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <p id="errorModalMsg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./ProfileEdit.js"></script>

<style src="./ProfileEdit.scss" scoped lang="scss"></style>
